<template>
  <div id="app">
    <LoginOverlay />
    <Desktop />
  </div>
</template>

<script>
import LoginOverlay from "./components/login/LoginOverlay";
import Desktop from "./components/Desktop";

export default {
  name: "App",
  components: {
    LoginOverlay,
    Desktop,
  },
};
</script>

<style lang="scss">
@import "@/assets/variables";

body {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  color: $primary-text-black;
  margin: 0;
  user-select: none;
  overflow: hidden;
}

button {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  outline: 0;
}
</style>
